(() => {
  const customers = document.querySelector('.customers-section');

  if (!customers) {
    return;
  }

  const track = customers.querySelector('[data-customers-track]');
  const previousButton = customers.querySelector('[data-customers-prev]');
  const nextButton = customers.querySelector('[data-customers-next]');

  if (!track || !previousButton || !nextButton) {
    return;
  }

  const updateControls = () => {
    const maxScroll = track.scrollWidth - track.clientWidth;
    previousButton.disabled = track.scrollLeft <= 1;
    nextButton.disabled = track.scrollLeft >= maxScroll - 1;
  };

  const getScrollDistance = () => {
    const card = track.querySelector('.customers-section__card');
    const gap = Number.parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 0;

    return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
  };

  previousButton.addEventListener('click', () => {
    track.scrollBy({ left: -getScrollDistance(), behavior: 'smooth' });
  });

  nextButton.addEventListener('click', () => {
    track.scrollBy({ left: getScrollDistance(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', updateControls, { passive: true });
  window.addEventListener('resize', updateControls);
  updateControls();
})();

(() => {
  const modal = document.querySelector('#numbers-modal');
  if (!modal) return;

  const triggers = document.querySelectorAll('[data-numbers-modal-trigger]');
  const closeButtons = modal.querySelectorAll('[data-numbers-modal-close]');
  const form = modal.querySelector('[data-numbers-form]');
  const cpfInput = modal.querySelector('#numbers-cpf');
  const status = modal.querySelector('[data-numbers-form-status]');
  const results = modal.querySelector('[data-numbers-results]');
  const queryPanel = modal.querySelector('[data-numbers-query]');
  const submitButton = form?.querySelector('button[type="submit"]');
  let backdrop;
  let lastTrigger;

  const onlyDigits = (value) => value.replace(/\D/g, '');

  const maskCpf = (value) => onlyDigits(value).slice(0, 11)
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');

  const isValidCpf = (value) => {
    const cpf = onlyDigits(value);
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
    let sum = 0;
    for (let index = 0; index < 9; index += 1) sum += Number(cpf[index]) * (10 - index);
    let remainder = (sum * 10) % 11;
    if (remainder === 10) remainder = 0;
    if (remainder !== Number(cpf[9])) return false;
    sum = 0;
    for (let index = 0; index < 10; index += 1) sum += Number(cpf[index]) * (11 - index);
    remainder = (sum * 10) % 11;
    if (remainder === 10) remainder = 0;
    return remainder === Number(cpf[10]);
  };

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#039;',
    '"': '&quot;',
  }[character]));

  const setStatus = (message) => {
    if (!status) return;
    status.textContent = message;
    status.classList.toggle('visually-hidden', !message);
  };

  const setCpfError = (message) => {
    if (!cpfInput) return;
    cpfInput.setCustomValidity(message || '');
    cpfInput.classList.toggle('is-invalid', Boolean(message));
    const errorElement = modal.querySelector('[data-numbers-field-error="cpf"]');
    if (errorElement) {
      errorElement.textContent = message || '';
      errorElement.classList.toggle('d-block', Boolean(message));
    }
  };

  const clearResults = () => {
    if (!results) return;
    results.hidden = true;
    results.innerHTML = '';
  };

  const renderResults = (data) => {
    if (!results) return;
    const numeros = Array.isArray(data.numeros) ? data.numeros : [];
    if (data.possui_numeros && numeros.length) {
      results.innerHTML = `
        <p class="numbers-modal__result-title">Olá, <strong>${escapeHtml(data.nome || 'participante')}</strong>!</p>
        <p class="numbers-modal__result-text">Abaixo estão seus números da sorte:</p>
        <div class="numbers-modal__badges" aria-label="Seus números da sorte">
          ${numeros.map((numero) => `<span class="numbers-modal__badge">${String(numero).padStart(5, '0')}</span>`).join('')}
        </div>`;
    } else {
      results.innerHTML = '<p class="numbers-modal__result-text mb-0">Você ainda não possui números da sorte. Para participar compre R$ 5.000,00 ou mais em produtos Eliane nas lojas participantes em todo o território nacional.</p>';
    }
    results.hidden = false;
  };

  const closeModal = () => {
    modal.classList.remove('show');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
    backdrop?.remove();
    backdrop = null;
    lastTrigger?.focus();
    lastTrigger = null;
  };

  const openModal = (event) => {
    event.preventDefault();
    lastTrigger = event.currentTarget;
    clearResults();
    setStatus('');
    setCpfError('');
    form?.reset();
    if (queryPanel) queryPanel.hidden = false;
    modal.classList.add('show');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
    backdrop = document.createElement('div');
    backdrop.className = 'modal-backdrop fade show';
    backdrop.addEventListener('click', closeModal);
    document.body.append(backdrop);
    cpfInput?.focus();
  };

  cpfInput?.addEventListener('input', () => {
    cpfInput.value = maskCpf(cpfInput.value);
    if (form?.classList.contains('was-validated')) setCpfError(isValidCpf(cpfInput.value) ? '' : 'Informe um CPF válido.');
  });

  triggers.forEach((trigger) => trigger.addEventListener('click', openModal));
  closeButtons.forEach((button) => button.addEventListener('click', closeModal));
  modal.addEventListener('click', (event) => {
    if (event.target === modal) closeModal();
  });
  document.addEventListener('keydown', (event) => {
    if (modal.classList.contains('show') && event.key === 'Escape') closeModal();
  });

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    form.classList.add('was-validated');
    if (!isValidCpf(cpfInput?.value || '')) {
      setCpfError('Informe um CPF válido.');
      cpfInput?.focus();
      return;
    }

    if (submitButton) submitButton.disabled = true;
    setStatus('Consultando seus números da sorte...');
    clearResults();

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      });
      const data = await response.json();
      if (!response.ok || !data.success) throw new Error(data.message || 'Não foi possível consultar seus números da sorte.');
      setStatus('');
      if (queryPanel) queryPanel.hidden = true;
      renderResults(data);
    } catch (error) {
      setStatus(error.message || 'Não foi possível consultar seus números da sorte.');
    } finally {
      if (submitButton) submitButton.disabled = false;
    }
  });
})();

(() => {
  const modal = document.querySelector('#contact-modal');
  if (!modal) return;

  const triggers = document.querySelectorAll('[data-contact-modal-trigger]');
  const closeButtons = modal.querySelectorAll('[data-contact-modal-close]');
  const form = modal.querySelector('[data-contact-form]');
  const status = modal.querySelector('[data-contact-form-status]');
  const phoneInput = modal.querySelector('#contact-phone');
  let backdrop;
  let lastTrigger;

  const closeModal = () => {
    modal.classList.remove('show');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
    backdrop?.remove();
    backdrop = null;
    lastTrigger?.focus();
    lastTrigger = null;
  };

  const openModal = (event) => {
    event.preventDefault();
    lastTrigger = event.currentTarget;
    modal.classList.add('show');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
    backdrop = document.createElement('div');
    backdrop.className = 'modal-backdrop fade show';
    backdrop.addEventListener('click', closeModal);
    document.body.append(backdrop);
    modal.querySelector('input, textarea, button')?.focus();
  };

  const setStatus = (message) => {
    if (!status) return;
    status.textContent = message;
    status.classList.toggle('visually-hidden', !message);
  };

  const maskPhone = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 11);
    if (digits.length <= 10) {
      return digits.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3').trim();
    }
    return digits.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3').trim();
  };

  phoneInput?.addEventListener('input', () => {
    phoneInput.value = maskPhone(phoneInput.value);
  });

  triggers.forEach((trigger) => trigger.addEventListener('click', openModal));
  closeButtons.forEach((button) => button.addEventListener('click', closeModal));
  modal.addEventListener('click', (event) => {
    if (event.target === modal) closeModal();
  });
  document.addEventListener('keydown', (event) => {
    if (modal.classList.contains('show') && event.key === 'Escape') closeModal();
  });

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    form.classList.add('was-validated');
    if (!form.checkValidity()) return;

    const submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) submitButton.disabled = true;
    setStatus('Enviando mensagem...');

    try {
      const response = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || !result.success) throw new Error(result.message || 'Não foi possível enviar a mensagem.');
      form.reset();
      setStatus('');
      if (window.Swal) {
        await window.Swal.fire({ title: 'Mensagem enviada', html: result.message, icon: 'success', confirmButtonText: 'Fechar' });
      }
      closeModal();
    } catch (error) {
      setStatus(error.message || 'Não foi possível enviar a mensagem.');
      if (window.Swal) window.Swal.fire({ title: 'Erro ao enviar', html: error.message, icon: 'error', confirmButtonText: 'Fechar' });
    } finally {
      if (submitButton) submitButton.disabled = false;
    }
  });
})();

(() => {
  const header = document.querySelector('.promotion-header');

  if (!header) {
    return;
  }

  const menuToggle = header.querySelector('.promotion-header__toggle');
  const navigation = header.querySelector('.promotion-header__nav');
  const navigationLinks = header.querySelectorAll('.promotion-header__link');

  if (!menuToggle || !navigation) {
    return;
  }

  const closeMenu = () => {
    navigation.classList.remove('is-open');
    menuToggle.setAttribute('aria-expanded', 'false');
    menuToggle.setAttribute('aria-label', 'Abrir menu');
  };

  menuToggle.addEventListener('click', () => {
    const isOpen = navigation.classList.toggle('is-open');

    menuToggle.setAttribute('aria-expanded', String(isOpen));
    menuToggle.setAttribute('aria-label', isOpen ? 'Fechar menu' : 'Abrir menu');
  });

  navigationLinks.forEach((link) => {
    link.addEventListener('click', closeMenu);
  });

  window.addEventListener('resize', () => {
    if (window.matchMedia('(min-width: 992px)').matches) {
      closeMenu();
    }
  });
})();

(() => {
  const faq = document.querySelector('.faq-section');

  if (!faq) {
    return;
  }

  const triggers = faq.querySelectorAll('.faq-section__trigger');

  const setItemState = (item, isOpen) => {
    const trigger = item.querySelector('.faq-section__trigger');
    const answerId = trigger.getAttribute('aria-controls');
    const answer = document.getElementById(answerId);

    item.classList.toggle('is-open', isOpen);
    trigger.setAttribute('aria-expanded', String(isOpen));

    if (answer) {
      answer.hidden = !isOpen;
    }
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.faq-section__item');
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';

      faq.querySelectorAll('.faq-section__item.is-open').forEach((openItem) => {
        if (openItem !== item) {
          setItemState(openItem, false);
        }
      });

      setItemState(item, !isOpen);
    });
  });
})();

(() => {
  const modal = document.querySelector('.note-modal');

  if (!modal) {
    return;
  }

  const triggers = document.querySelectorAll('[data-note-modal-trigger]');
  const closeButtons = modal.querySelectorAll('[data-note-modal-close]');
  const form = modal.querySelector('[data-note-form]');
  const fileInput = modal.querySelector('#invoice-file');
  const dropzone = modal.querySelector('[data-note-dropzone]');
  const fileName = modal.querySelector('[data-note-file-name]');
  const status = modal.querySelector('[data-note-form-status]');
  const defaultFileMessage = fileName ? fileName.textContent : '';
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let backdrop;
  let lastTrigger;

  const getFocusableElements = () => Array.from(modal.querySelectorAll(focusableSelector));

  const closeModal = () => {
    modal.classList.remove('show');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');

    if (backdrop) {
      backdrop.remove();
      backdrop = null;
    }

    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  };

  const openModal = (event) => {
    event.preventDefault();
    lastTrigger = event.currentTarget;
    modal.classList.add('show');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');

    backdrop = document.createElement('div');
    backdrop.className = 'modal-backdrop fade show';
    backdrop.addEventListener('click', closeModal);
    document.body.append(backdrop);

    const firstFocusableElement = getFocusableElements()[0];

    if (firstFocusableElement) {
      firstFocusableElement.focus();
    }
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', openModal);
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (!modal.classList.contains('show')) {
      return;
    }

    if (event.key === 'Escape') {
      closeModal();
      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    const focusableElements = getFocusableElements();
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    if (!firstFocusableElement || !lastFocusableElement) {
      return;
    }

    if (event.shiftKey && document.activeElement === firstFocusableElement) {
      event.preventDefault();
      lastFocusableElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastFocusableElement) {
      event.preventDefault();
      firstFocusableElement.focus();
    }
  });

  const setStatus = (message) => {
    if (!status) {
      return;
    }

    status.textContent = message;
  };

  const updateSelectedFile = (files) => {
    const file = files && files[0];

    if (!file || !fileName) {
      return;
    }

    const isAllowedType = /^(application\/pdf|image\/(jpeg|png))$/i.test(file.type) || /\.(pdf|jpe?g|png)$/i.test(file.name);

    if (!isAllowedType || file.size > 10 * 1024 * 1024) {
      fileInput.value = '';
      fileName.textContent = defaultFileMessage;
      dropzone.classList.remove('has-file');
      setFieldError(fileInput, 'Selecione um PDF, JPG ou PNG de até 10MB.');
      setStatus('Selecione um arquivo PDF, JPG ou PNG de até 10MB.');
      return;
    }

    fileName.textContent = file.name;
    dropzone.classList.add('has-file');
    setFieldError(fileInput, '');
    setStatus('Arquivo selecionado: ' + file.name);
  };

  const onlyDigits = (value) => value.replace(/\D/g, '');

  const maskCpf = (value) => {
    const digits = onlyDigits(value).slice(0, 11);
    return digits
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  };

  const maskCep = (value) => onlyDigits(value).slice(0, 8).replace(/(\d{5})(\d)/, '$1-$2');

  const maskPhone = (value) => {
    const digits = onlyDigits(value).slice(0, 11);
    if (digits.length <= 10) {
      return digits.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3').trim();
    }
    return digits.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3').trim();
  };

  const isValidCpf = (value) => {
    const digits = onlyDigits(value);
    if (digits.length !== 11 || /^([0-9])\1{10}$/.test(digits)) {
      return false;
    }

    let sum = 0;
    for (let index = 0; index < 9; index += 1) {
      sum += Number(digits[index]) * (10 - index);
    }
    let remainder = (sum * 10) % 11;
    if (remainder === 10) remainder = 0;
    if (remainder !== Number(digits[9])) return false;

    sum = 0;
    for (let index = 0; index < 10; index += 1) {
      sum += Number(digits[index]) * (11 - index);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10) remainder = 0;
    return remainder === Number(digits[10]);
  };

  const getFieldError = (field) => modal.querySelector(`[data-field-error="${field.name}"]`);

  const setFieldError = (field, message) => {
    if (!field) return;
    field.setCustomValidity(message || '');
    field.classList.toggle('is-invalid', Boolean(message));
    field.classList.toggle('is-valid', !message && field.value);
    const errorElement = getFieldError(field);
    if (errorElement) {
      errorElement.textContent = message || '';
      errorElement.classList.toggle('d-block', Boolean(message));
    }
  };

  const validateField = (field) => {
    if (!field) return true;
    const value = field.type === 'file' ? field.files.length : field.value.trim();
    let message = '';

    if (field.required && !value && field.type !== 'checkbox') message = 'Campo obrigatório.';
    if (field.type === 'checkbox' && field.required && !field.checked) message = 'Aceite o regulamento para continuar.';
    if (!message && field.name === 'cpf' && !isValidCpf(field.value)) message = 'Informe um CPF válido.';
    if (!message && field.name === 'phone' && ![10, 11].includes(onlyDigits(field.value).length)) message = 'Informe um telefone com 8 ou 9 dígitos após o DDD.';
    if (!message && field.name === 'postal_code' && onlyDigits(field.value).length !== 8) message = 'Informe um CEP válido.';
    if (!message && field.type === 'email' && field.value && !field.validity.valid) message = 'Informe um e-mail válido.';
    if (!message && field.name === 'state' && field.value.length !== 2) message = 'Selecione o estado.';
    if (!message && field.name === 'invoice' && field.files.length === 0) message = 'Envie o arquivo da nota fiscal.';

    setFieldError(field, message);
    return !message;
  };

  const validateAllFields = () => {
    const fields = ['name', 'cpf', 'phone', 'email', 'postal_code', 'street', 'number', 'neighborhood', 'city', 'state', 'network', 'invoice', 'terms']
      .map((name) => form.elements[name]);
    return fields.map(validateField).every(Boolean);
  };


  const fillAddressByCep = async () => {
    const cepField = form.elements.postal_code;
    const cep = onlyDigits(cepField.value);
    if (cep.length !== 8) return;

    setStatus('Consultando o endereço pelo CEP...');
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const address = await response.json();
      if (!response.ok || address.erro) {
        setFieldError(cepField, 'CEP não encontrado.');
        return;
      }
      form.elements.street.value = address.logradouro || '';
      form.elements.neighborhood.value = address.bairro || '';
      form.elements.city.value = address.localidade || '';
      form.elements.state.value = address.uf || '';
      ['street', 'neighborhood', 'city', 'state'].forEach((name) => validateField(form.elements[name]));
      setFieldError(cepField, '');
      setStatus('Endereço preenchido automaticamente.');
    } catch (error) {
      setStatus('Não foi possível consultar o CEP. Preencha o endereço manualmente.');
    }
  };

  ['cpf', 'postal_code', 'phone'].forEach((name) => {
    const field = form.elements[name];
    field?.addEventListener('input', () => {
      if (name === 'cpf') field.value = maskCpf(field.value);
      if (name === 'postal_code') field.value = maskCep(field.value);
      if (name === 'phone') field.value = maskPhone(field.value);
      if (form.classList.contains('was-validated')) validateField(field);
      if (name === 'postal_code' && onlyDigits(field.value).length === 8) fillAddressByCep();
    });
  });

  Array.from(form.elements).forEach((field) => {
    if (!field.name) return;
    field.addEventListener('blur', () => validateField(field));
  });

  if (fileInput && dropzone) {
    fileInput.addEventListener('change', () => {
      updateSelectedFile(fileInput.files);
    });

    ['dragenter', 'dragover'].forEach((eventName) => {
      dropzone.addEventListener(eventName, (event) => {
        event.preventDefault();
        dropzone.classList.add('is-dragging');
      });
    });

    ['dragleave', 'drop'].forEach((eventName) => {
      dropzone.addEventListener(eventName, (event) => {
        event.preventDefault();
        dropzone.classList.remove('is-dragging');
      });
    });

    dropzone.addEventListener('drop', (event) => {
      const files = event.dataTransfer.files;

      if (!files.length) {
        return;
      }

      try {
        fileInput.files = files;
      } catch (error) {
        // Browsers that block FileList assignment still expose the selected file name below.
      }

      updateSelectedFile(files);
    });
  }

  if (form) {

    const debug = false;

    const classesSweetAlertPublico = {
      container: 'promotion-swal-container',
      popup: 'promotion-swal-popup',
      htmlContainer: 'promotion-swal-html',
      actions: 'promotion-swal-actions',
      confirmButton: 'promotion-swal-confirm',
    };

    const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#039;',
      '"': '&quot;',
    }[character]));

    const htmlSweetAlertPublico = (titulo, texto) => `
      <div class="promotion-swal-message">
        <img class="promotion-swal-message__slogan" src="assets/img/hero/slogan.svg" alt="Construindo sonhos Eliane">
        <h2 class="promotion-swal-message__title">${escapeHtml(titulo)}</h2>
        <div class="promotion-swal-message__body">${texto}</div>
      </div>`;

    const configurarSweetAlertPublico = (configuracao, titulo, texto) => {
      if (debug) return configuracao;
      const { title, text, html, customClass, icon, ...resto } = configuracao;
      return {
        ...resto,
        html: htmlSweetAlertPublico(titulo, texto),
        customClass: classesSweetAlertPublico,
      };
    };

    const lerRespostaJson = async (response, etapa) => {
      const corpo = await response.text();
      if (!corpo.trim()) {
        throw new Error(`O servidor retornou uma resposta vazia durante a ${etapa} (HTTP ${response.status}).`);
      }

      try {
        return JSON.parse(corpo);
      } catch (error) {
        throw new Error(`O servidor retornou uma resposta inválida durante a ${etapa} (HTTP ${response.status}).`);
      }
    };

    const atualizarProcessamento = (titulo, texto, icone = 'info', mostrarLoading = false) => {
      if (window.Swal) {
        if (debug) {
          window.Swal.update({ title: titulo, html: texto });
        } else {
          window.Swal.update({
            html: htmlSweetAlertPublico(titulo, texto),
            customClass: classesSweetAlertPublico,
          });
          if (mostrarLoading) window.Swal.showLoading();
        }
      }
      setStatus(`${titulo} ${texto}`);
    };

    const mostrarErroProcessamento = (mensagem) => {
      if (window.Swal) {
        const configuracao = {
          title: 'Não foi possível concluir',
          html: mensagem,
          confirmButtonText: 'Fechar',
        };
        window.Swal.fire(configurarSweetAlertPublico(configuracao, 'Não foi possível concluir', escapeHtml(mensagem)));
      }
      setStatus(mensagem);
    };

    const consultarProcessamento = async (codigo) => {
      const inicio = Date.now();
      const limite = 5 * 60 * 1000;

      while (Date.now() - inicio < limite) {
        const response = await fetch(`api/status-nota.php?codigo=${encodeURIComponent(codigo)}`, {
          headers: { Accept: 'application/json' },
        });
        const status = await lerRespostaJson(response, 'consulta do status da nota');

        if (!response.ok || !status.success) {
          throw new Error(status.message || 'Não foi possível consultar o status da nota.');
        }

        if (status.status === 'validada' || status.status === 'reprovada' || status.status === 'analise' || status.status === 'erro') {
          const totalProdutos = Number(status.total_produtos_eliane || 0).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          });
          atualizarProcessamento(
            debug ? '4/5 — Validando produtos e valores' : 'Aguarde',
            debug
              ? `Conferência concluída.<br>Total identificado em produtos Eliane: <strong>${totalProdutos}</strong>.`
              : 'A nota fiscal está sendo validada.',
            status.status === 'validada' ? 'success' : (status.status === 'erro' ? 'error' : 'warning'),
            !debug,
          );
          await new Promise((resolve) => window.setTimeout(resolve, 900));
          return status;
        }
        const jobStatus = status.job_status || 'processing';
        atualizarProcessamento(
          debug ? '3/4 — Processando no Nuveo' : 'Aguarde',
          debug
            ? `O job <strong>${status.job_id || 'foi criado'}</strong> está com status <strong>${jobStatus}</strong>.<br>Estamos aguardando o retorno seguro da validação.`
            : 'A nota fiscal está sendo processada.',
            'info',
            !debug,
          );
        await new Promise((resolve) => window.setTimeout(resolve, 3000));
      }

      throw new Error('O processamento está demorando mais que o esperado. Você pode acompanhar a validação pelo e-mail informado.');
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      form.classList.add('was-validated');

      if (!validateAllFields()) {
        const firstInvalidField = form.querySelector('.is-invalid, :invalid');

        if (firstInvalidField) {
          firstInvalidField.focus();
        }

        return;
      }

      const submitButton = form.querySelector('button[type="submit"]');
      if (submitButton) {
        submitButton.disabled = true;
      }
      setStatus('Salvando sua nota fiscal...');
      status?.classList.remove('visually-hidden');

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' },
        });
        const result = await lerRespostaJson(response, 'salvamento da nota');

        if (!response.ok || !result.success) {
          throw new Error(result.message || 'Não foi possível enviar o formulário.');
        }

        if (window.Swal) {
          const configuracao = {
            title: '1/4 — Nota salva',
            html: `Participação <strong>#${result.codigo}</strong> registrada com segurança.<br>Preparando o envio para o Nuveo...`,
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => window.Swal.showLoading(),
          };
          window.Swal.fire(configurarSweetAlertPublico(
            configuracao,
            'Aguarde',
            'Participação registrada.<br>Preparando a validação da nota fiscal...',
          ));
        }

        if (!debug)
          atualizarProcessamento('Aguarde', 'A nota fiscal está sendo enviada para validação.', 'info', true);
        else
          atualizarProcessamento('2/4 — Enviando para o Nuveo', 'O arquivo foi salvo e está sendo enviado para criação do job de OCR.', 'info');

        const envioResponse = await fetch('api/api-envia-notas.php', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          },
          body: new URLSearchParams({ codigo: String(result.codigo) }),
        });
        const envio = await lerRespostaJson(envioResponse, 'envio da nota para o Nuveo');
        if (!envioResponse.ok || !envio.success) {
          if (!debug)
            throw new Error(envio.message || 'A nota foi salva, mas não pôde ser enviada validada.');
          else
            throw new Error(envio.message || 'A nota foi salva, mas não pôde ser enviada ao Nuveo.');
        }

        if (!debug)
          atualizarProcessamento(
          'Aguarde',
          `A nota fiscal está sendo processada.`,
          'info',
          true,
          );
        else
          atualizarProcessamento(
            '3/4 — Job Nuveo criado',
            `Job <strong>${envio.job_id}</strong> recebido pelo serviço OCR.<br>Agora o documento será processado de forma assíncrona.`,
            'info',
          );

        const processamento = await consultarProcessamento(result.codigo);
        if (processamento.status === 'validada') {
          if (window.Swal) {
            const configuracaoAntesDoResultado = {
              title: 'SÃO MUITAS CHANCES DE GANHAR!',
              html: 'Compre produtos Eliane, concorra a prêmios instantâneos e ainda concorra a uma grande viagem no final da promoção.',
              allowOutsideClick: false,
              allowEscapeKey: false,
              confirmButtonText: 'CLIQUE AQUI E DESCUBRA SE GANHOU!',
            };
            await window.Swal.fire(configurarSweetAlertPublico(
              configuracaoAntesDoResultado,
              'SÃO MUITAS CHANCES DE GANHAR!',
              'Compre produtos Eliane, concorra a prêmios instantâneos e ainda concorra a uma grande viagem no final da promoção.',
            ));
          }

          const premioValor = processamento.premio_valor === null || processamento.premio_valor === undefined
            ? null
            : Number(processamento.premio_valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
          const possuiPremio = processamento.premio_status === 'sorteado'
            && processamento.premio
            && Number(processamento.premio_valor || 0) > 0;
          const numeroDaSorteQtde = processamento.numeros_da_sorte.length;
          const numerosDaSorte = Array.isArray(processamento.numeros_da_sorte)
            ? processamento.numeros_da_sorte.map((numero) => String(numero).padStart(5, '0')).join(', ')
            : '';
          const resumoNumerosDaSorte = numerosDaSorte
            ? `<br><br><strong>${numerosDaSorte}</strong>`
            : '';
          if (window.Swal) {
            const corpoResultado = possuiPremio
              ? `<h5>Você foi contemplado com um vale-compras de ${escapeHtml(processamento.premio)} para usar na rede onde realizou a compra.</h5>Você também recebeu ${numeroDaSorteQtde} número(s) da sorte e continua concorrendo ao super prêmio final da promoção. Seus números da sorte:${resumoNumerosDaSorte}<br><br><small>Em caso de dúvidas, entre em contato com nossa equipe pelo Fale Conosco.<br>Estamos à disposição para ajudar!<small>`
              : `Desta vez, você não ganhou um vale-compras instantâneo, mas recebeu ${numeroDaSorteQtde} número(s) da sorte e continua concorrendo ao super prêmio final. Confira seus números da sorte:${resumoNumerosDaSorte}<br><br><small>Em caso de dúvidas, entre em contato com nossa equipe pelo Fale Conosco.<br>Estamos à disposição para ajudar!<small>`;

            const configuracao = {
              title: '5/5 — Resultado do sorteio',
              html: possuiPremio
                ? `Sua nota foi validada e você ganhou:<br><strong>${processamento.premio}</strong> (${premioValor}).${resumoNumerosDaSorte}.`
                : `Sua nota foi validada e não recebeu prêmio instantâneo.${resumoNumerosDaSorte}.`,
              confirmButtonText: 'Concluir',
            };
            await window.Swal.fire(configurarSweetAlertPublico(configuracao, (possuiPremio ? 'PARABÉNS' : 'Sua participação foi registrada!'), corpoResultado));
          }
        } else if (processamento.status === 'analise') {
          if (window.Swal) {
            const textoAnalise = (!debug)
              ? 'Olá! Agradecemos sua participação em nossa promoção!<br><br>O documento enviado não foi reconhecido automaticamente pelo sistema, mas não se preocupe! Nossa equipe fará uma análise para verificar sua validade.<br><br>Caso o documento esteja de acordo com o regulamento da promoção, sua nota fiscal será validada e sua participação no sorteio será liberada normalmente.<br><br>Você receberá a confirmação por e-mail assim que a análise for concluída.<br><br>Agradecemos sua compreensão e desejamos boa sorte!'
              : (processamento.validation_message || 'A nota será analisada manualmente pela equipe da campanha.');
            const configuracao = {
              title: (!debug) ? 'Documento em análise' : '4/4 — Nota em análise',
              html: textoAnalise,
              confirmButtonText: 'Entendi',
            };
            await window.Swal.fire(configurarSweetAlertPublico(configuracao, (!debug) ? 'Documento em análise' : 'Participação enviada', (!debug) ? textoAnalise : escapeHtml(textoAnalise)));
          }
        } else if (processamento.status === 'reprovada') {
          if (window.Swal) {
            const lojaNaoCadastrada = processamento.validation_status === 'loja_nao_cadastrada';
            const textoReprovacao = (!debug)
              ? 'Olá! Agradecemos sua participação em nossa promoção!<br><br>O documento enviado não foi reconhecido automaticamente pelo sistema, mas não se preocupe! Nossa equipe fará uma análise para verificar sua validade.<br><br>Caso o documento esteja de acordo com o regulamento da promoção, sua nota fiscal será validada e sua participação no sorteio será liberada normalmente.<br><br>Você receberá a confirmação por e-mail assim que a análise for concluída.<br><br>Agradecemos sua compreensão e desejamos boa sorte!'
              : (lojaNaoCadastrada
                ? (processamento.validation_message || 'O CNPJ da loja emitente não está cadastrado como loja participante.')
                : (processamento.validation_message || 'A nota não atendeu aos critérios de validação.'));
            const configuracao = {
              title: (!debug) ? 'Documento em análise' : (lojaNaoCadastrada ? '4/4 — Loja não participante' : '4/4 — Nota não validada'),
              html: textoReprovacao,
              confirmButtonText: 'Entendi',
            };
            await window.Swal.fire(configurarSweetAlertPublico(configuracao, (!debug) ? 'Documento em análise' : 'Atenção', (!debug) ? textoReprovacao : escapeHtml(textoReprovacao)));
          }
        } else if (processamento.status === 'erro') {
          if (window.Swal) {
            const textoErro = processamento.validation_message || processamento.error || 'Não foi possível concluir a validação da nota.';
            const configuracao = {
              title: (!debug) ? 'Atenção' : '4/4 — Erro no processamento',
              html: textoErro,
              confirmButtonText: 'Fechar',
            };
            await window.Swal.fire(configurarSweetAlertPublico(configuracao, 'Atenção', escapeHtml(textoErro)));
          }
        }

        form.reset();
        if (fileName) {
          fileName.textContent = defaultFileMessage;
        }
        dropzone?.classList.remove('has-file');
      } catch (error) {
        if (window.Swal) {
          window.Swal.close();
        }
        if ((!debug))
          mostrarErroProcessamento(error.message || 'Não foi possível concluir o processamento.');
        else
          mostrarErroProcessamento(error.message || 'Não foi possível concluir o processamento.');
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
        }
      }
    });
  }
})();
(() => {
  if (typeof window.AOS === 'undefined') {
    return;
  }

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.documentElement.classList.add('aos-ready');

  window.AOS.init({
    disable: prefersReducedMotion,
    duration: 700,
    easing: 'ease-out-cubic',
    once: true,
    offset: 72,
    delay: 0,
  });
})();
